<div class="">
  <!-- <div class="company-sm-logo">
    <img src="assets/images/layout/Mr_DIY_Small.png" alt="">
  </div> -->
  <a [routerLink]="['/dashboard/']">
    <div class="company-logo">
      <img src="assets/images/layout/Mr_diy_Logo.png" alt="">
    </div>
    <div class="company-sm-logo"></div>
  </a>

  <a href="javascript:" class="mobile-menu" [ngClass]="{ on: navCollapsed }" id="mobile-collapse" (click)="navCollapse()">
    @if (!navCollapsed) {
      <img src="assets/icons/layout/Icon_Expand.svg" alt="">
    }
    @else {
      <i class="icon expand-right-icon"></i>
    }
  </a>
  <!-- <a href="javascript:" class="mobile-menu" [ngClass]="{ on: navCollapsed }" id="mobile-collapse" (click)="navCollapse()"><span></span></a> -->
</div>
